import { Selector } from "./selectors"

export const StockDocumentSelector = Selector


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/selectors/index.ts